<template>
    <v-select
        :items         = "codes"
        item-value     = "id"
        item-text      = "name"
        label          = "Ländercode"
        v-model        = "seletced"
        :return-object = true
        @change        = "onChange"
        :readonly      = "readonly"
        :hide-details  = "true"
        class          = "country-select"
    >
        <template v-slot:item="{ item }">
            {{ item.flag }} {{ item.phone }} {{ item.name }}
        </template>
        <template v-slot:selection="{ item }">
            {{ item.flag }} {{ item.phone }}
        </template>
    </v-select>
</template>

<script>

import Core from "@/modules/core/service/Core";
import getUnicodeFlagIcon from 'country-flag-icons/unicode'

export default {
    name: "FCountry",

    components: {
    },

    props: {
        readonly: {
            required: false,
            type    : Boolean,
            default : false
        },

        value: {

        },
    },

    data: () => ({
        seletced: null,
        codes   : []
    }),

    mounted() {
        const countries = this.$store.getters ['msd']['countries'];
        countries.forEach ((country) => {
            this.codes.push ({
                id   : country.id,
                name : country.name,
                phone: country.phone,
                code : country.iso3166,
                flag : this.flag(country.iso3166)
            });
        })

        this.initialize();
    },

    watch: {
        value () {
            this.initialize();
        }
    },

    methods: {
        initialize () {
            const defaultLanguage = Core.message.language();
            this.seletced = this.value ? this.codes.find(c => c.phone === this.value) : this.codes.find(c => c.code === defaultLanguage);
        },

        onChange () {
            this.$emit('input', this.seletced.phone);
        },

        flag (unicode) {
            return getUnicodeFlagIcon(unicode);
        }
    }
}
</script>

<style scoped>

.country-select {
    width: 80px;
    min-width: 80px;
    max-width: 80px;
    margin-top: 0;
}

</style>